/**
 * Dynamically add missing elements to the Smart Cart of Rebuy
 */

// Function to get the cart element from the DOM.
const getCartElement = () => document.getElementById('rebuy-cart');

// Function to update an item in the cart.
const updateItem = (cartElement, item) => {
  const productClass = `.product-${item.handle}`;
  const itemElement = cartElement.querySelector(productClass);

  if (!itemElement) return;

  // Extract the metafield from the item's product data.
  const elementMetafield = item.product.metafields?.custom?.material;

  if (!elementMetafield) return;

  const materialElementClass = 'rebuy-cart__flyout-item-material';

  // If the material element already exists, exit the function.
  if (itemElement.querySelector(`.${materialElementClass}`)) return;

  // Find the variant title element and prepare to add the material element.
  const variantElement = itemElement.querySelector('.rebuy-cart__flyout-item-variant-title');
  const materialElement = document.createElement('div');
  materialElement.className = materialElementClass;
  materialElement.textContent = elementMetafield;
  // Insert the material element before the variant title.
  variantElement.before(materialElement);
};

// Function to update all items in the cart with their metafields.
const updateItemsWithMetafields = async (smartcart) => {
  const cartElement = getCartElement();
  if (!cartElement) return;

  smartcart.cart.items.forEach((item) => {
    updateItem(cartElement, item);
  });
};

// Function to copy payment icons to the cart footer.
const copyPaymentIcons = () => {
  const container_selector = '.payment-icons__list';
  const cartElement = getCartElement();
  const cart_footer = cartElement.querySelector('.rebuy-cart__flyout-footer');
  const container = document.querySelector(container_selector);

  if (!container || !cart_footer) return;

  // Check if the cart footer already has payment icons.
  const has_icons = cart_footer.querySelector(container_selector);
  if (has_icons) return;

  // Clone the container and adjust its classes and children.
  const clone = container.cloneNode(true);

  // Remove icons after the 4th one.
  Array.from(clone.children).forEach((child, i) => {
    if (i > 3) child.remove();
  });

  // Update the classes for the cloned container so it fits to design
  clone.classList.remove('justify-center');
  clone.classList.remove('gap-4');
  clone.classList.add('gap-2');
  // Append the cloned container to the cart footer.
  cart_footer.append(clone);
};

// Event listener for when the smartcart is shown.
document.addEventListener('rebuy:smartcart.show', async (event) => {
  // Wait for the cart footer to render before executing the functions.
  await waitForElementToRender('.rebuy-cart__flyout-footer');

  const smartcart = event.detail.smartcart;
  // Update the items with metafields and copy the payment icons.
  updateItemsWithMetafields(smartcart);
  copyPaymentIcons(smartcart);
});

// Event listener for when an item is added to the cart.
document.addEventListener('rebuy:cart.add', (event) => {
  updateItemsWithMetafields(event.detail.cart);
});
